import { CalendarClock, ExternalLink } from "lucide-react";

/** Client Portal v2 (2026-09, Phase 1, §5) — read-only surface of Decisions + Action Items
 * only, per meeting. Never shows the internal Notes/Transcript link (see modules/meetings.py's
 * own docstring) — the backend whitelist strips it, this component simply never references a
 * `notes_url` field. "Schedule a meeting" is a plain external Calendly link. Sits between
 * Messages and Updates in Communication (§5's reorder). */
export function MeetingsList({ meetings, calendlyUrl }) {
  return (
    <div>
      {calendlyUrl && (
        <a href={calendlyUrl} target="_blank" rel="noreferrer" data-testid="client-portal-schedule-meeting-btn"
          className="inline-flex items-center gap-2 cp-btn-outline px-4 py-2.5 mb-5">
          <CalendarClock className="h-3.5 w-3.5" /> Schedule a meeting <ExternalLink className="h-3 w-3" />
        </a>
      )}
      {meetings.length === 0 ? (
        <p className="text-[13.5px] text-[color:var(--cp-grey-3)]" data-testid="client-portal-meetings-empty">Meeting summaries and action items will appear here after your calls with the team.</p>
      ) : (
        <div data-testid="client-portal-meetings-list">
          {meetings.map((m) => (
            <div key={m.id} className="cp-row-divider py-4" data-testid={`client-portal-meeting-${m.id}`}>
              <div className="flex items-center justify-between gap-4 mb-2">
                <h4 className="text-[14.5px] font-semibold text-[color:var(--cp-ink-text)]">{m.name}</h4>
                <span className="text-[10.5px] font-semibold uppercase tracking-wide text-[color:var(--cp-grey-4)] shrink-0">{m.date}{m.type ? ` · ${m.type}` : ""}</span>
              </div>
              {m.decisions && (
                <div className="mb-2">
                  <div className="cp-eyebrow text-[10px] mb-1">Decisions</div>
                  <p className="text-[13px] text-[color:var(--cp-grey-1)] leading-relaxed whitespace-pre-wrap">{m.decisions}</p>
                </div>
              )}
              {m.action_items && (
                <div>
                  <div className="cp-eyebrow text-[10px] mb-1">Action Items</div>
                  <p className="text-[13px] text-[color:var(--cp-grey-1)] leading-relaxed whitespace-pre-wrap">{m.action_items}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
